module.exports = __webpack_public_path__ + "img/img43.0c33b21a.png";